<template>
  <div>
    <b-card no-body>
      <b-tabs content-class="m-3" card lazy>
        <b-tab title="Все" active>
          <b-table v-if="$auth.user().license" striped hover :fields="fieldsAll" :items="licenses">
            <template v-slot:cell(activated_at)="data">
              <span v-if="data.item.activated_at">{{
                parseInt(data.item.activated_at) | moment("timezone", $moment.tz.guess(), "lll")
              }}</span>
              <span v-else>–</span>
            </template>
            <template v-slot:cell(time)="data">
              <span v-if="data.item.activated_at">
                {{
                  (parseInt(data.item.activated_at) + parseInt(data.item.time))
                    | moment("timezone", $moment.tz.guess(), "lll")
                }}</span
              >
              <span v-else>–</span>
            </template>
            <template v-slot:cell(status)="data">
              <h6 v-if="!data.item.activated_at">
                <b-btn size="sm" @click="activateKey(data.item.id, data.index)">Активировать</b-btn>
              </h6>
              <h6
                v-else-if="
                  parseInt(data.item.activated_at) + parseInt(data.item.time) > parseInt(new Date().getTime() / 1000)
                "
                class="text-success"
              >
                Активен
              </h6>
              <h6 v-else class="text-danger">Истёк</h6>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="Физ. лица (счета)">
          <b-table striped hover :fields="fieldsFiz" :items="indPayments">
            <template v-slot:cell(created_at)="data">
              {{ parseInt(data.created_at) | moment("timezone", $moment.tz.guess(), "lll") }}
            </template>
            <template v-slot:cell(packageId)="data">
              {{ data.item.package.name }}
            </template>
            <template v-slot:cell(file)="data">
              <b-button :href="process.env.VUE_APP_API_URL + '/' + data.item.file">Скачать</b-button>
            </template>
            <template v-slot:cell(status)="data">
              <h6 class="text-primary">Ожидает оплаты</h6>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="Юр. лица (счета)">
          <h4>Текущие счета</h4>
          <b-table striped hover :fields="fieldsLegal" :items="legalPayments">
            <template v-slot:cell(created_at)="data">
              {{ parseInt(data.item.created_at) | moment("timezone", $moment.tz.guess(), "lll") }}
            </template>
            <template v-slot:cell(packageId)="data">
              {{ data.item.package.name }}
            </template>
            <template v-slot:cell(file)="data">
              <b-button :href="process.env.VUE_APP_API_URL + '/' + data.item.file">Скачать</b-button>
            </template>
            <template v-slot:cell(status)="data">
              <h6 class="text-primary">Ожидает оплаты</h6>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="МСТ">
          <h4>Лицензии</h4>
          <b-table striped hover :fields="fields" :items="mstLicenses">
            <template v-slot:cell(key)="data">
              {{ data.item.key }}
              <div class="pt-1" v-if="data.item.description && data.item.description.length > 0">
                <i>Примечание: {{ data.item.description }}</i>
              </div>
            </template>
            <template v-slot:cell(package)="data">
              <span v-if="data.item.package && data.item.package.name"> {{ data.item.package.name }}</span>
              <span v-else>Не найден</span>
            </template>
            <template v-slot:cell(activated_at)="data">
              <span v-if="data.item.activated_at">
                <h6
                  v-if="
                    parseInt(data.item.activated_at) + parseInt(data.item.time) > parseInt(new Date().getTime() / 1000)
                  "
                  class="text-success"
                >
                  Активен до
                  {{
                    (parseInt(data.item.activated_at) + parseInt(data.item.time))
                      | moment("timezone", $moment.tz.guess(), "lll")
                  }}
                </h6>
                <h6 v-else class="text-danger">
                  Истёк ({{
                    (parseInt(data.item.activated_at) + parseInt(data.item.time))
                      | moment("timezone", $moment.tz.guess(), "lll")
                  }})
                </h6>
                <i
                  v-b-tooltip.hover
                  :title="
                    'ИД: ' +
                    data.item.user.user_id +
                    ' - ' +
                    data.item.user.last_name +
                    ' ' +
                    data.item.user.name +
                    ' ' +
                    data.item.user.second_name
                  "
                  class="fa fa-lg fa-user"
                  aria-hidden="true"
                ></i>
              </span>
              <span v-else>
                <h6 class="text-primary">Не активирован</h6>
              </span>
            </template>
            <template v-slot:cell(status)="data">
              <h6 v-if="data.item.status == 0" class="text-danger">Заблокирован</h6>
              <h6 v-if="data.item.status == 1" class="text-primary">
                Сформирован счёт
                <a href="#" @click="download(data.item.id)"
                  ><i class="fa fa-lg fa-file-word-o" aria-hidden="true"></i
                ></a>
              </h6>
              <h6 v-if="data.item.status == 2" class="text-primary">
                Проверка оплаты
                <a href="#" @click="download(data.item.id)"
                  ><i class="fa fa-lg fa-file-word-o" aria-hidden="true"></i
                ></a>
              </h6>
              <h6 v-if="data.item.status == 3" class="text-success">Оплачен</h6>
            </template>
            <template v-slot:cell(actions)="data">
              <b-btn
                v-if="data.item.status == 2"
                href="javascript: void(0)"
                class="m-1 p-2"
                variant="primary"
                size="sm"
                @click="confirm(data.item.id, data.index)"
              >
                <i class="fa fa-money"></i> Подтвердить оплату
              </b-btn>
              <b-btn
                v-if="data.item.status == 1"
                href="javascript: void(0)"
                class="m-1 p-2"
                variant="danger"
                size="sm"
                @click="remove(data.item.id, data.index)"
              >
                <i class="fa fa-trash mx-1"></i>
              </b-btn>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      packeges: [],
      licenses: [],
      mstLicenses: [],
      legalPayments: [],
      indPayments: [],
      form: {
        package: null,
        description: "",
      },
      fields: [
        // A column that needs custom formatting
        { key: "key", label: "Ключ" },
        { key: "package", label: "Тариф" },
        { key: "activated_at", label: "Статус" },
        { key: "status", label: "Оплата" },
        { key: "actions", label: "Действия" },
      ],
      fieldsFiz: [
        // A column that needs custom formatting
        { key: "key", label: "Ключ" },
        { key: "package", label: "Тариф" },
        { key: "created_at", label: "Создан" },
        { key: "status", label: "Статус" },
        { key: "actions", label: "Действия" },
      ],
      fieldsLegal: [
        // A column that needs custom formatting
        { key: "created_at", label: "Создан" },
        // A virtual column made up from two fields
        { key: "packageId", label: "Пакет" },
        // A virtual column made up from two fields
        { key: "file", label: "Счёт" },
        // A virtual column made up from two fields
        { key: "status", label: "Статус" },
      ],
      fieldsAll: [
        // A column that needs custom formatting
        { key: "key", label: "Ключ" },
        // A virtual column made up from two fields
        { key: "activated_at", label: "Активирован" },
        // A virtual column made up from two fields
        { key: "time", label: "Истекает" },
        // A virtual column made up from two fields
        { key: "status", label: "Статус" },
      ],
    };
  },
  computed: {
    sum() {
      var pack = this.packeges.find((el) => el.id == this.form.package);
      if (pack) {
        return pack.cost - (pack.cost * this.$auth.user().discount) / 100;
      }
      return null;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$http
        .post("admin/keys/get-list")
        .then((response) => {
          this.packeges = response.data.packages;
          this.mstLicenses = response.data.mstLicenses;
          this.legalPayments = response.data.legalPayments;
          this.licenses = response.data.licenses;
          this.indPayments = response.data.indPayments;
          this.form.package = this.packeges[0].id;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    remove(id, index) {
      this.$http
        .get("payment/remove-mst-key", {
          params: {
            id: id,
          },
        })
        .then(() => {
          this.mstLicenses.splice(index, 1);
        });
    },
    confirm(id, index) {
      this.$http
        .get("payment/confirm-mst-payment", {
          params: {
            id: id,
          },
        })
        .then((response) => {
          this.$set(this.mstLicense, index, response.data);
        });
    },
    download(id) {
      this.$http({
        url: "payment/mst-download-payment?id=" + id,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "Счёт " + id + ".pdf");
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
  },
};
</script>
